var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 100",
    width: 900,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 100,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64L10.7 60.3C21.3 56.7 42.7 49.3 64.2 44.8C85.7 40.3 107.3 38.7 128.8 43.5C150.3 48.3 171.7 59.7 193 60.2C214.3 60.7 235.7 50.3 257 50.5C278.3 50.7 299.7 61.3 321.2 65.2C342.7 69 364.3 66 385.8 63.2C407.3 60.3 428.7 57.7 450 55.3C471.3 53 492.7 51 514.2 50.7C535.7 50.3 557.3 51.7 578.8 49.7C600.3 47.7 621.7 42.3 643 41.5C664.3 40.7 685.7 44.3 707 45.2C728.3 46 749.7 44 771.2 41.7C792.7 39.3 814.3 36.7 835.8 37C857.3 37.3 878.7 40.7 889.3 42.3L900 44L900 101L889.3 101C878.7 101 857.3 101 835.8 101C814.3 101 792.7 101 771.2 101C749.7 101 728.3 101 707 101C685.7 101 664.3 101 643 101C621.7 101 600.3 101 578.8 101C557.3 101 535.7 101 514.2 101C492.7 101 471.3 101 450 101C428.7 101 407.3 101 385.8 101C364.3 101 342.7 101 321.2 101C299.7 101 278.3 101 257 101C235.7 101 214.3 101 193 101C171.7 101 150.3 101 128.8 101C107.3 101 85.7 101 64.2 101C42.7 101 21.3 101 10.7 101L0 101Z",
    fill: "#DBC9C5",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLight);
export default __webpack_public_path__ + "static/media/footerLight.4ba9843513985b045baeda7798004bdd.svg";
export { ForwardRef as ReactComponent };